module.exports = __webpack_public_path__ + "static/media/mute_icon.549bc4e0.svg";